import React from "react";

export function FollowIcon(props: React.SVGAttributes<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.74314 3.81741C8.54938 3.60779 10.387 3.5 12.25 3.5C14.113 3.5 15.9506 3.60779 17.7569 3.81741C18.4607 3.89909 19 4.51078 19 5.25699V19.5365L12.5854 16.3292C12.3743 16.2236 12.1257 16.2236 11.9146 16.3292L5.5 19.5365V5.25699C5.5 4.51078 6.03933 3.89909 6.74314 3.81741ZM12.25 2C10.329 2 8.43374 2.11114 6.57022 2.32741C5.07283 2.50119 4 3.78722 4 5.25699V20.75C4 21.0099 4.13459 21.2513 4.3557 21.388C4.57681 21.5246 4.85292 21.5371 5.08541 21.4208L12.25 17.8385L19.4146 21.4208C19.6471 21.5371 19.9232 21.5246 20.1443 21.388C20.3654 21.2513 20.5 21.0099 20.5 20.75V5.25699C20.5 3.78722 19.4272 2.50119 17.9298 2.32741C16.0663 2.11114 14.171 2 12.25 2ZM13.25 7.18938C13.25 6.51958 12.9197 5.73931 12.25 5.75C11.5848 5.76062 11.25 6.52149 11.25 7.1868V8.75H9.68842C9.02001 8.75 8.25 9.08159 8.25 9.75C8.25 10.4184 9.02001 10.75 9.68842 10.75H11.25V12.3116C11.25 12.98 11.5816 13.75 12.25 13.75C12.9184 13.75 13.25 12.98 13.25 12.3116V10.75H14.6126C15.336 10.75 16.25 10.4734 16.25 9.75C16.25 9.0266 15.336 8.75 14.6126 8.75H13.25V7.18938Z"
        fill="currentColor"
      />
    </svg>
  );
}
